import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';

var TRANSITION_DURATION = 225;
var TRANSITION_SETTINGS = TRANSITION_DURATION + "ms ease-in-out";
var ICON_WIDTH = pxToRem(16);
var ICON_CONTAINER_WIDTH = pxToRem(32);
var LOGOTYPE_PADDING = "calc((" + ICON_CONTAINER_WIDTH + " - " + ICON_WIDTH + ") / 2)";
var LIST_GAP = themeGet('spacing.sm');
var LIST_SCROLLBAR_OFFSET = pxToRem(4);
var SIDEBAR_PADDING = themeGet('spacing.xl');

export { ICON_CONTAINER_WIDTH, ICON_WIDTH, LIST_GAP, LIST_SCROLLBAR_OFFSET, LOGOTYPE_PADDING, SIDEBAR_PADDING, TRANSITION_DURATION, TRANSITION_SETTINGS };
